import * as React from 'react';
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry';
import {
  faChevronRight as fasChevronRight
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function SpacesTabContent ( props ) {
  return (
    <div className="tab-content bg-master-lightest-important pt-4">
      {
        props.spaces.length > 0 &&
                props.spaces.map( ( position, index ) => {
                  let tab_pane_class = 'tab-pane fade';
                  tab_pane_class += index == 0 ? '\ show active' : '';
                  const this_position = position.tab;

                  return (
                    <div id={this_position.tab_id} key={this_position.tab_id.toString()} className={tab_pane_class}>
                      {
                        position.content.length > 0 &&
                                    <ResponsiveMasonry
                                      columnsCountBreakPoints={{ 576: 1, 768: 2 }}
                                    >
                                      <Masonry
                                        gutter="30px"
                                        options={{
                                          columnWidth: 1,
                                        }}
                                      >
                                        {
                                          position.content.map( ( space ) => {
                                            return (

                                              <div className="w-100" key={space.space_id.toString()}>
                                                <div
                                                  className="block-title p-b-15 text-black m-b-0">{space.space_title}
                                                  <FontAwesomeIcon icon={fasChevronRight}
                                                    className="text-black m-l-10 fw-normal fs-11 align-baseline"/>
                                                </div>
                                                <div className="p-elem mb-0"
                                                  dangerouslySetInnerHTML={{ __html: space.space_description }}/>
                                              </div>
                                            );

                                          })
                                        }
                                      </Masonry>
                                    </ResponsiveMasonry>
                      }
                    </div>
                  )
                })
      }
    </div>
  )
}
